import styled from "styled-components";
import { RecordNotfoundIcon } from "./Icons/RecordNotfoundIcon";
import { useWindowSize } from "../hook/useWindowSize";
import { useApp } from "../contexts";

const Container = styled.div`
  width: 100%;
  height: 180px;
  background: #ffffff;
  border-radius: 15px;
  display: flex;
  gap: 22px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    height: 155px;
    border-radius: 10px;
    gap: 0px;
  }
`;

export const RecordNotFound = () => {
  const size = useWindowSize();
  const isMobile = size.width < 1024;
  const { T } = useApp();
  return (
    <Container>
      <RecordNotfoundIcon
        width={isMobile ? 64 : 78}
        height={isMobile ? 64 : 78}
      />
      <span className="text-[16px] leading-[22px] text-[#818181] mt-[18px] text-center">
        {T("No records found.")}
      </span>
    </Container>
  );
};
